import { useState } from 'react';

import { ActionDialog } from '@/components/shared/components/ActionDialog';
import { Text } from '@/components/shared/components/Text';

interface CloseConfirmationAlertProps {
  opened: boolean;
  setOpened: (value: boolean) => void;
  toggleDialog: () => void;
  onLeave: () => Promise<void>;
}

export const CloseConfirmationAlert = ({ opened, setOpened, toggleDialog, onLeave }: CloseConfirmationAlertProps) => {
  const [loading, setLoading] = useState(false);

  const handleLeave = async () => {
    setLoading(true);
    await onLeave();
    setLoading(false);
  };

  return (
    <ActionDialog
      loading={loading}
      opened={opened}
      setOpened={setOpened}
      handleClose={toggleDialog}
      Title={<Text tId={'CLOSE_VALIDATION_TITLE'} />}
      onSubmit={handleLeave}
      Description={<Text tId={'CLOSE_VALIDATION_DESCRIPTION'} />}
      MainButton={<Text tId={'RESET'} />}
    />
  );
};
